import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=610a6196&"
import script from "./employees.vue?vue&type=script&lang=js&"
export * from "./employees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports